import React, {Dispatch, SetStateAction, useCallback, useEffect} from "react";
import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableRow,
} from "@mui/material";
import {EStatus, IResponseUserTO} from "../../models/user";
import ChipStatus from "../chip-status";
import SubMenuTable from "../submenu-table";
import {useNavigate} from "react-router-dom";
import {UserService} from "../../services/user-service";
import Toast from "../toast";
import { TableCellStyle } from "./styles";
import DataTableLoadingComponent from "../datatable-loading-component";
import StyledTableHead from "../table-head";
import {ITableHeadCell, Order} from "../../interfaces/table-head";


interface IPropsDataTable {
  data: IResponseUserTO[];
  update: () => void;
  order: Order;
  orderBy: string;
  setOrder: Dispatch<SetStateAction<Order>>;
  setOrderBy: Dispatch<SetStateAction<string>>;
  loading?: boolean;
}

export default function DataTable(props: IPropsDataTable) {

  const navigate = useNavigate();

  const rows = props.data;

  useEffect(() => {
  }, [rows]);

  function edit(data: IResponseUserTO) {
    navigate("/usuarios/editar/" + data.id, {state: data});
  }

  const handleUpdate = useCallback(
    async (user: IResponseUserTO) => {
      const result = await UserService.updateUser(user);
      if (typeof result === "object") {
        Toast.success("Usuário atualizado com sucesso!");
        props.update();
      }
    }, [props]
  );

  function updateStatus(data: IResponseUserTO) {
    if (data.status == EStatus.ACTIVE) {
      data.status = EStatus.BLOCKED;
    } else if (data.status == EStatus.BLOCKED) {
      data.status = EStatus.ACTIVE;
    }
    handleUpdate(data);
  }

  function whichStatus(status : EStatus){
    if(status == EStatus.BLOCKED){
      return "Ativar";
    } else if (status == EStatus.ACTIVE) {
      return "Bloquear";
    }
  }

  function handleSort(value: string) {
    if (value !== undefined) {
      if (props.orderBy === value) {
        props.order === "asc" ? props.setOrder("desc") : props.setOrder("asc");
      } else {
        props.setOrder("asc");
        props.setOrderBy(value);
      }
    }
  }

  const head: ITableHeadCell[] =
    [
      {name: "name", label: "Nome", align: "left", width: 25},
      {name: "email", label: "Email", align: "left", width: 40},
      {name: "username", label: "Usuário", align: "left", width: 10},
      {name: "status", label: "Status", align: "center", width: 15},
    ];

  return (
    <TableContainer>
      <Table sx={{minWidth: 700}} aria-label="customized table">
        <StyledTableHead head={head} orderBy={props.orderBy} order={props.order} onRequestSort={handleSort}/>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCellStyle><Checkbox /></TableCellStyle>
              <TableCellStyle align="left">{row.name}</TableCellStyle>
              <TableCellStyle align="left">{row.email}</TableCellStyle>
              <TableCellStyle align="left">{row.username}</TableCellStyle>
              <TableCellStyle align="left"><ChipStatus status={row.status} /></TableCellStyle>
              <TableCellStyle align="center">
                <SubMenuTable nameStatus={whichStatus(row.status)} edit={() => edit(row)} updateStatus={() => updateStatus(row)} />
              </TableCellStyle>
            </TableRow>
          ))}
          {props.loading && <DataTableLoadingComponent />}
          </TableBody>
      </Table>
    </TableContainer>
  );
}
